import { request } from "@/utils/request";

export const countingForAll = () => {
  return request.get("/HomePage/countingForAll");
};
